import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { createContext } from 'react';
import { DescendantProvider, useDescendant } from './8986a05d86aebcb7d0fc7a5d2d905bf20944e51b0f072accfcded64a874f24c8.cfe-internal.js';

var _excluded = ["element"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var noop = function noop(param) {}; // eslint-disable-line @typescript-eslint/no-unused-vars

var ChildIndexContext = /*#__PURE__*/createContext({
  descendants: [],
  registerDescendant: noop,
  unregisterDescendant: noop
});
var ChildIndexProvider = function ChildIndexProvider(_ref) {
  var items = _ref.items,
    setItems = _ref.setItems,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(DescendantProvider, {
    context: ChildIndexContext,
    items: items,
    set: setItems
  }, children);
};
function useChildIndex(_ref2) {
  var element = _ref2.element,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return useDescendant(_objectSpread({
    element: element
  }, rest), ChildIndexContext);
}

export { ChildIndexContext, ChildIndexProvider, useChildIndex };
